export default function BankingIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.4"
        d="M10.3083 2.2917L17.8083 5.29168C18.1 5.40835 18.3333 5.75834 18.3333 6.06667V8.83335C18.3333 9.29168 17.9583 9.66668 17.5 9.66668H2.49996C2.04163 9.66668 1.66663 9.29168 1.66663 8.83335V6.06667C1.66663 5.75834 1.89996 5.40835 2.19163 5.29168L9.69163 2.2917C9.8583 2.22503 10.1416 2.22503 10.3083 2.2917Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M18.3333 18.8333H1.66663V16.3333C1.66663 15.875 2.04163 15.5 2.49996 15.5H17.5C17.9583 15.5 18.3333 15.875 18.3333 16.3333V18.8333Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.21688 9.6665V15.4998H3.13354V9.6665H5.21688ZM9.10034 9.6665V15.4998H7.01701V9.6665H9.10034ZM12.983 9.6665V15.4998H10.8997V9.6665H12.983ZM16.8665 9.6665V15.4998H14.7831V9.6665H16.8665Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.208374 18.8335C0.208374 18.4883 0.488196 18.2085 0.833374 18.2085H19.1667C19.5119 18.2085 19.7917 18.4883 19.7917 18.8335C19.7917 19.1787 19.5119 19.4585 19.1667 19.4585H0.833374C0.488196 19.4585 0.208374 19.1787 0.208374 18.8335Z"
        fill="currentColor"
      />
      <path
        d="M10 7.5835C10.6904 7.5835 11.25 7.02385 11.25 6.3335C11.25 5.64314 10.6904 5.0835 10 5.0835C9.30964 5.0835 8.75 5.64314 8.75 6.3335C8.75 7.02385 9.30964 7.5835 10 7.5835Z"
        fill="currentColor"
      />
    </svg>
  );
}
